<!-- @format -->

<div
	id="pdp-add-to-cart"
	class="hmf-display-flex hmf-justify-content-between hmf-flex-column">
	<pdp-feature-add-to-cart-button
		class="hmf-flex-grow hmf-display-flex hmf-justify-content-between hmf-mb-m"
		[ecode]="ecode()"
	></pdp-feature-add-to-cart-button>
	@if (favoritesEnabled) {
		<shared-favorites-components-auth-icon
			class="hmf-mb-m"
			[ecode]="ecode()"
			[resolvedSku]="resolvedSkuPartNumber"
			[location]="favoritesLocation"
			[isCustomizable]="isCustomizable()"
			[customAttributes]="customizedAttributes()"
			[isAuthenticated]="isAuthenticated"
			[listProductPersonalization]="listProductPersonalization"
			[isSingleSkuProduct]="isSingleSkuProduct()">
		</shared-favorites-components-auth-icon>
	}
	<pdp-feature-add-to-cart-alerts></pdp-feature-add-to-cart-alerts>
</div>
